export const generateStagesLife = (map) => (request) => {
  const { stageAddressLifeCycle } = request;
  const id = stageAddressLifeCycle?.id || 0;

  const entity = map.get(id) || {
    name: stageAddressLifeCycle ? stageAddressLifeCycle?.name : 'Не указан',
    amount: 0,
    id,
  };

  entity.amount += 1;

  map.set(id, entity);
};

export default generateStagesLife;
